import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=21e913cc&scoped=true&"
import script from "./Inbox.vue?vue&type=script&lang=ts&"
export * from "./Inbox.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/helpdesk/inbox.css?vue&type=style&index=0&id=21e913cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e913cc",
  null
  
)

export default component.exports